<div class="graph-wrapper">
  <canvas id="radarChart" style="width: 276px; height: 258px"></canvas>
</div>
